import {
  LogOut,
  LucideSunMoon,
  LucideUserCircle,
  Moon,
  Sun,
  User,
} from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useNavigate } from "react-router-dom";
import { LuBookMarked } from "react-icons/lu";
import { useState } from "react";
import { useTheme } from "../store/themeProvider";
import { Button } from "@/components/ui/button";
import { FaUser } from "react-icons/fa6";
import { Paths } from "../constants/Paths";

export default function ProfileTop() {
  const navigate = useNavigate();
  const { setTheme, theme } = useTheme();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon" className="rounded-full p-2">
          <FaUser className="w-4 h-4 text-foreground/60 transition-colors hover:text-foreground/80" />
        </Button>
        {/* <Avatar className="cursor-pointer"> */}
        {/* <AvatarImage src={null} alt="Poojan Bhattarai" /> */}
        {/* <AvatarFallback>
						{getWordsInitials(
							isEmpty(localStorage.fullName)
								? "User"
								: localStorage.fullName
						)}
					</AvatarFallback> */}
        {/* </Avatar> */}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => navigate("/profile")}>
          <User className="mr-2 h-4 w-4" />
          <span>Profile</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate(Paths.MY_BOOKINGS)}>
          <LuBookMarked className="mr-2 h-4 w-4" />
          <span>My Bookings</span>
        </DropdownMenuItem>

        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            {theme === "light" && <Sun className="mr-2 h-4 w-4" />}
            {theme === "dark" && <Moon className="mr-2 h-4 w-4" />}
            {theme === "system" && <LucideSunMoon className="mr-2 h-4 w-4" />}
            <span>Color Mode</span>
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>
                <DropdownMenuRadioItem
                  value="light"
                >
                  Light
                </DropdownMenuRadioItem>
                <DropdownMenuRadioItem
                  value="dark"
                >
                  Dark
                </DropdownMenuRadioItem>
                <DropdownMenuRadioItem
                  value="system"
                  onClick={() => setTheme("system")}
                >
                  System
                </DropdownMenuRadioItem>
              </DropdownMenuRadioGroup>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>

        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            navigate("/logout");
          }}
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log Out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
